import { render, staticRenderFns } from "./ReferrerPopup.vue?vue&type=template&id=032f278f&"
import script from "./ReferrerPopup.vue?vue&type=script&lang=js&"
export * from "./ReferrerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports